import axios from "@/request";
import qs from "qs";

export default {
  /* 新建场馆 */
  async add_stadium(params: any) {
    return axios.post("invest/add-stadium", qs.stringify(params));
  },
  /* 保存场馆信息 */
  async save_stadium(params: any) {
    return axios.post("invest/save-stadium", qs.stringify(params));
  },
  /* 场馆详情 */
  async stadium_info(params: any) {
    return axios.get("invest/stadium-info", { params });
  },
  // 场馆管理 - 场馆列表
  async list_stadium(params: any) {
    return axios.get("invest/list-stadium", { params });
  },
  /* 我的场馆 */
  async my_stadium(params: any) {
    return axios.get("invest/my-stadium", { params });
  },
  /* 设置协议编号 */
  async config_agreement(params: any) {
    return axios.post("invest/config-agreement", qs.stringify(params));
  },
  /* 释放协议编号 */
  async release_agreement(params: any) {
    return axios.post("invest/release-agreement", qs.stringify(params));
  },
  /* 设置馆长信息 */
  async config_manager(params: any) {
    return axios.post("invest/config-manager", qs.stringify(params));
  },
  /* 分配|移交 场馆 */
  async config_stadium(params: any) {
    return axios.post("invest/config-stadium", qs.stringify(params));
  },
  /* 设置失效 */
  async set_invalid(params: any) {
    return axios.post("invest/set-invalid", qs.stringify(params));
  },
  /* 场馆失效详情 */
  async invalid_info(params: any) {
    return axios.get("invest/invalid-info", { params });
  },
  /* 分享配置 */
  async prepare_share(params: any) {
    return axios.post("invest/prepare-share", qs.stringify(params));
  },
  /* 提交审核 */
  async submit(params: any) {
    return axios.post("invest/submit", qs.stringify(params));
  },
}
